<template>
  <div v-if="isROOT">
    <div class="center">
      <div @click="openModalAdm = !openModalAdm" class="sidebarModalButton">
        <div class="iconModal">
          <b-icon pack="fas" icon="user"></b-icon>
        </div>
        <div class="nameModalClient">
          <span class="hoveredTitle" v-if="haveClient">
            Trocar Cliente
            <!-- {{ getClientName }} -->
          </span>
          <span class="hoveredTitle" v-else>
            Trocar Cliente
          </span>
          <br />
        </div>
      </div>

      <vs-dialog v-model="openModalAdm">
        <h4 class="not-margin">
          Selecione seu Cliente
        </h4>
        <br />
        <div class="con-form">
          <b-field v-if="isROOT">
            <b-select
              placeholder="Escolha um cliente"
              expanded
              @input="choiceGroup($event)"
              icon="globe"
              :value="getGroupID"
            >
              <option
                v-for="listedGroup in selectedGroupList"
                :key="listedGroup.id"
                :value="listedGroup.id"
                >{{ listedGroup.text }}</option
              >
            </b-select>
          </b-field>

          <b-field v-if="isROOT && exib_client_list">
            <b-select
              placeholder="Escolha um cliente"
              expanded
              @input="choiceClient($event)"
              icon="building"
              v-model="selectedClient"
              :loading="clientList.length == 0"
            >
              <option
                v-for="client in clientList"
                :key="client.id"
                :value="client.id"
                >{{ client.name }}</option
              >
            </b-select>
          </b-field>

          <b-field v-if="isADM && !isROOT">
            <b-select
              placeholder="Escolha um cliente"
              expanded
              @input="choiceClient($event)"
              icon="building"
              v-model="selectedClient"
              :loading="getClients.length == 0"
            >
              <option
                v-for="client in getClients"
                :key="client.id"
                :value="client.id"
                >{{ client.name }}</option
              >
            </b-select>
          </b-field>

          <vs-button block v-on:click="openModalAdm = false">
            Concluído
          </vs-button>
        </div>
      </vs-dialog>
    </div>
  </div>
</template>

<script>
import Webservices from "@/Webservices";
import store from "@/store";
import { mapActions, mapGetters, mapState } from "vuex";
import TimeMe from "timeme.js";

const ws = new Webservices();

export default {
  data() {
    return {
      exib_client_list: true,
      selectedGroup: null,
      selectedGroupList: [],
      clientList: [],
      selectedClient: null,
      currentSelectedClient: undefined,
      lastSelectedClient: undefined,
      exibe_bar: true,
      activeItem: "dashboard",
      openModalAdm: false
    };
  },
  computed: {
    ...mapState({ client: state => state.client, group: state => state.group }),
    ...mapGetters([
      "isLoggedIn",
      "getCurrentPage",
      "getCurrentModal",
      "getName",
      "isADM",
      "getPhoto",
      "isDark",
      "getClient",
      "getClientName",
      "getClientLogo",
      "isROOT",
      "getRules",
      "getClients",
      "getClientID",
      "getClientsByGroupId",
      "getClientsByGroupIdShort",
      "getGroupsByFatherId",
      "getToken",
      "getGroupID"
    ]),
    haveClient() {
      if (store.state.client) {
        return store.state.client.id != null;
      } else {
        return false;
      }
    },
    haveClientNotGroup() {
      return (
        store.state.client &&
        store.state.client.id != null &&
        store.state.client.id != "all"
      );
    },
    clientHasMap() {
      return store.state.client && store.state.client.coordinates != null;
    },
    clientHasNotifications() {
      return store.state.client && store.state.client.mapActive != null;
    }
  },
  watch: {
    isROOT() {
      if (this.isROOT) {
        this.getSchoolGroup().then(() => {
          this.choiceGroup(this.selectedGroupList[0].id).then(() => {
            if (this.clientList[0].id == "all") {
              this.choiceClient(this.clientList[1].id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          });
        });
      }
    },

    getCurrentPage(page) {
      TimeMe.stopAllTimers();
      TimeMe.startTimer(page);
    },

    getCurrentModal(modal) {
      TimeMe.stopAllTimers();
      if (modal === undefined) {
        const path = this.$router.currentRoute.path;
        const page = this.getCurrentPage;

        TimeMe.startTimer(page);
      } else {
        TimeMe.startTimer(modal);
      }
    }
  },
  mounted() {
    if (this.isROOT) {
      this.getSchoolGroup().then(() => {
        this.choiceGroup(this.selectedGroupList[0].id).then(() => {
          if (this.clientList[0].id == "all") {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[1].id);
            }
          } else {
            if (store.state.client && store.state.client.id) {
              this.choiceClient(store.state.client.id);
            } else {
              this.choiceClient(this.clientList[0].id);
            }
          }
        });
      });
    }
  },
  methods: {
    ...mapActions(["logout", "selectClient"]),

    //Estudar alguma forma de mandar esses dados periodicamente
    //Atualmente os dados são enviados em LOGOUT/FECHAR ABA/MUDAR PARA OUTRA PAGINA/TROCA DE CLIENTE
    /* sendTimeData(client_id) {
      TimeMe.stopAllTimers();
      const time_per_page = TimeMe.getTimeOnAllPagesInSeconds();

      this.initTimers();

      //Vai dar return quando o cliente inicial ainda não foi definido
      if (client_id == undefined) return;

      const { userId: user_id } = JSON.parse(localStorage.getItem("data"));

      let dataToSend = {
        user_id,
        client_id,
        time_per_page,
        datetime: new Date().toISOString()
      };

      ws.sendTimePerPage(dataToSend);
    },
 */
    //Reinicializa os cronometros
    initTimers() {
      const path = this.$router.currentRoute.path;

      TimeMe.resetAllRecordedPageTimes();

      TimeMe.initialize({
        idleTimeoutInSeconds: 600,

        currentPageName: this.getCurrentPage
      });
    },
    choiceClient(clientId) {
      if (clientId == "all") {
        var client = {
          id: "all",
          name: "todos",
          controller_id: "all"
        };
      } else {
        var client = this.getClients.find(el => el.id == clientId);
      }
      //this.selectedClient = "5ed817c8b3a856200a282f3a"
      this.exibe_bar = false;
      //this.exib_client_list = false
      setTimeout(() => {
        this.exibe_bar = true;
        //this.exib_client_list = true;
      }, 250);
      store.state.group_client_await = false;
      this.selectClient(client);

      //Atualiza a informacao do ultimo cliente selecionado
      this.lastSelectedClient = this.currentSelectedClient;
      /* this.sendTimeData(this.lastSelectedClient); */

      const { client: client_info } = JSON.parse(localStorage.getItem("data"));
      this.currentSelectedClient =
        client_info != undefined ? client_info.controller_id : undefined;
      this.openModalAdm = false;
    },
    loadClient() {
      ws.getClientsByGroupId(store.state.groupId).then(res => {
        //console.log("res.data[0].id: ",res.data[0].id )
      });
    },
    getSchoolGroup() {
      return new Promise((resolve, reject) => {
        var groups = [];
        ws.getGroups().then(res => {
          var groups_ = res.data;
          var fathers = [];
          groups_.forEach(group => {
            if (fathers.indexOf(group.father_id) === -1) {
              fathers.push(group.father_id);
            }
          });

          groups_.forEach(group => {
            if (fathers.indexOf(group.id) === -1 || group.id != 99) {
              groups.push(group);
            }
          });

          this.selectedGroupList = groups;
          resolve(1);
        });
      });
    },
    choiceGroup(groupId) {
      this.exib_client_list = false;
      if (store.state.client) {
        store.state.client.ex_id = store.state.client.id;
        //store.state.client.id = "123";
      }

      return new Promise((resolve, reject) => {
        ws.getGroups().then(res => {
          this.selectedGroup = res.data.find(el => el.id == groupId);
          this.getClientsFromGroup().then(() => {
            resolve(1);
          });
        });
      });
    },
    getGroupList() {
      return this.selectedGroupList;
    },
    getClientsFromGroup() {
      store.state.group_client_await = true;
      return new Promise((resolve, reject) => {
        ws.getClientsByGroupIdShort(this.selectedGroup.id).then(resp => {
          this.exib_client_list = false;
          if (resp.data.length > 1) {
            this.exibe_bar = false;
            this.selectClient(resp.data[0]);
            setTimeout(() => {
              this.exibe_bar = true;
            }, 250);
            this.selectedClient = resp.data[0].id;
            store.state.group_client_await = false;
            this.clientList = [];

            for (let cliente of resp.data) {
              this.clientList.push({
                name: cliente.name,
                id: cliente.id
              });
            }
            this.clientList.unshift({
              name: "Todos",
              id: "all",
              radio_prefix: "all"
            });
          } else {
            this.clientList = resp.data;
            if (resp.data.length) {
              this.selectClient(resp.data[0]);
              this.selectedClient = resp.data[0].id;
              store.state.group_client_await = false;
            }
            //this.exib_client_list = true;
          }
          store.state.group_selected_clients = resp.data;
          store.state.group_selected = this.selectedGroup;
          setTimeout(() => {
            this.exib_client_list = true;
          }, 1000);
          resolve(1);
        });
      });
    },
    exit() {
      /*   this.sendTimeData(); */
      this.logout();
      this.$router.push("/login");
    },
    action(item) {
      if (item.hasOwnProperty("action")) item.action();
    }
  }
};
</script>

<style>
.iconModal {
  padding: 0px 10px 0px 0px;
}
.sidebarModalButton {
  color: white;
  width: 100%;
  cursor: pointer;
  padding: 7px 10px;
  margin: 10px 5px;
  display: flex;
  flex-direction: row;
  justify-content: start;
  transition: color 0.2s;
  transition: padding 0.2s;
}
.sidebarModalButton:hover {
  color: #f56618;
  padding: 7px 0px 7px 15px;
}
.hoveredTitle {
  height: 0;
  visibility: hidden;
  opacity: 0;
  transition: opacity 0.5s;
  display: flex;
  flex-direction: row;
}

.sidebar:hover .hoveredTitle {
  visibility: visible;
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// src/components/custom/sidebar/modalClient.vue